import './App.css';
import { useEffect, useState } from 'react';
import ButtonPad from './components/PadButton';
import Header from './components/Header';
import { Footer } from './components/Footer';
import ListLibraries from './components/ListLibraries';
import { useStorePads } from './store';
import useSoundPlayer from './hooks/useSoundPlayer';
import SetList from './components/SetList';
import { isAudioReady, startAudioEngine } from './audioManager';

function App() {
  const { currentLibrary } = useStorePads()
  const { pads } = useSoundPlayer()
  const [audioUnlocked, setAudioUnlocked] = useState(() => isAudioReady())
  const [isActivatingAudio, setIsActivatingAudio] = useState(false)

  const padsCurrentLibrary = pads[currentLibrary.name] || []

  useEffect(() => {
    setAudioUnlocked(isAudioReady())
  }, [])

  const handleActivateAudio = async () => {
    setIsActivatingAudio(true)

    try {
      const ready = await startAudioEngine()
      setAudioUnlocked(ready)
    } finally {
      setIsActivatingAudio(false)
    }
  }

  return (
    <div className="relative min-h-dvh grid grid-cols-1 sm:grid-cols-[1fr_auto]">
      <div className="min-h-dvh select-none grid grid-rows-[50px_50px_1fr_auto] sm:grid-rows-[50px_50px_1fr_60px]">
        <Header />
        <ListLibraries />
        <div className="grid grid-cols-3 gap-2 p-2 overflow-hidden">
          {
            padsCurrentLibrary.map((pad) => (
              <ButtonPad
                key={pad.note}
                note={pad.note}
                player={pad.player}
              />
            ))
          }
        </div>
        <Footer />
      </div>
      <SetList />
      {!audioUnlocked && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/75 px-6">
          <div className="w-full max-w-md rounded-xl border border-neutral-700 bg-neutral-900 p-6 text-center shadow-2xl">
            <h2 className="text-xl font-semibold">Activar audio</h2>
            <p className="mt-2 text-sm text-neutral-300">
              Safari y algunos navegadores móviles necesitan un toque antes de reproducir pads y metrónomo.
            </p>
            <button
              type="button"
              className="mt-5 w-full bg-white text-black hover:bg-neutral-200 disabled:cursor-not-allowed disabled:opacity-60"
              onClick={handleActivateAudio}
              disabled={isActivatingAudio}
            >
              {isActivatingAudio ? 'Activando...' : 'Tocar para activar audio'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}





export default App;
